import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import AuthProvider from './Components/AuthProvider/AuthProvider';
import APIProvider from './Components/AuthProvider/FetchAPIProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
const composeProviders = (...providers) => ({ children, ...props }) =>
  providers.reduceRight((acc, Provider) => <Provider {...props}>{acc}</Provider>, children);
const AppProviders = composeProviders(AuthProvider, APIProvider);
root.render(
  <React.StrictMode>
    <AppProviders>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProviders>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
